interface option {label:String,value:any}
export default (data: any) => {
  let list: any = [];
  data &&
    data.forEach((d: any) => {
      list.push({ ...d, label: d.Text || d.Name, value: d.Value || d.Id });
    });
  return list;
};
